import axios from 'axios';

// Shared axios factory for the mobile-mirrored screens (src/mobile/**).
// Desktop screens keep their existing per-call header pattern untouched.
export function createApiClient(API_URL) {
  const client = axios.create({ baseURL: API_URL });

  client.interceptors.request.use((config) => {
    const token = localStorage.getItem('jwtToken');
    if (token && !config.headers?.Authorization) {
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        localStorage.clear();
        window.dispatchEvent(new CustomEvent('legalapp:unauthorized'));
      }
      return Promise.reject(error);
    }
  );

  return client;
}
